__turbopack_context__.v({
  "article": "ArticleGridBlock-module__4YjSaW__article",
  "container": "ArticleGridBlock-module__4YjSaW__container",
  "containerReversed": "ArticleGridBlock-module__4YjSaW__containerReversed",
  "fadeInItems": "ArticleGridBlock-module__4YjSaW__fadeInItems",
  "feature": "ArticleGridBlock-module__4YjSaW__feature",
  "grid": "ArticleGridBlock-module__4YjSaW__grid",
  "spacing--lg": "ArticleGridBlock-module__4YjSaW__spacing--lg",
  "spacing--md": "ArticleGridBlock-module__4YjSaW__spacing--md",
  "spacing--sm": "ArticleGridBlock-module__4YjSaW__spacing--sm",
  "spacing--xl": "ArticleGridBlock-module__4YjSaW__spacing--xl",
  "spacing--xs": "ArticleGridBlock-module__4YjSaW__spacing--xs",
  "spacing--xxl": "ArticleGridBlock-module__4YjSaW__spacing--xxl",
  "spacing--xxs": "ArticleGridBlock-module__4YjSaW__spacing--xxs",
  "spacing--xxxl": "ArticleGridBlock-module__4YjSaW__spacing--xxxl",
  "spacing--xxxs": "ArticleGridBlock-module__4YjSaW__spacing--xxxs",
});
